import React from 'react';
import { Link } from 'react-router-dom';
import TOLogo from '../../../../static/images/TO/toyota-logo.svg'
import { Row, Image, Button } from 'react-bootstrap'
import AppVars from '../../../../AppVars';
import pushLinkAnalytics from '../../../../analytics/pushLinkAnalytics';
import pushAnalytics from '../../../../analytics/pushAnalytics';
const appVars = AppVars.getInstance();

const COMPONENT_TREE = [
    { component_name: 'RegisterComplete', component_version: '1.0.0' }
];

class RegisterCompleteView extends React.Component {
    render() {
        return (
            <div>
                <div className="justify-content-center line-box">
                    <div role="banner">
                        <Row className="">
                            <Link to={appVars.getAppHomeURL(this.props.style)}><Image className="corner-logo absolute" alt="Toyota" src={require('../../../../static/images/Toyota-Logo.svg').default} /></Link>
                        </Row>
                    </div>
                    <div role="main">
                        <Row className="justify-content-center location">
                            <div>Registration</div>
                        </Row>
                        <Row className="title__TO left">Check Your Email</Row>
                        <Row className="justify-content-center text__TO">
                            We sent an email to <b>{this.props.email}</b> with a link to verify your account and complete your registration. This link will be active for 72 hours.
                        </Row>
                        <Row className="justify-content-center text__TO">
                            Tip: If you don't see the email, make sure to check your spam folder.
                        </Row>
                        <Row className="justify-content-center text__TO">
                            Didn't receive the email?<br className="mobile-br" /> <Link style={{ "marginTop": "0px", "marginLeft": "10px" }} className="create-account" to={appVars.getResendActivationEmailURL(this.props.style)} onClick={() => pushLinkAnalytics({ ctaText: 'Resend Email', href: appVars.getResendActivationEmailURL(this.props.style), tree: COMPONENT_TREE })}>Resend Email</Link>
                        </Row>
                        <div>
                        </div>
                        <div style={{ 'display': 'grid', 'grid-template-rows': '60px', 'grid-template-columns': '176px', 'marginLeft': '-4px', 'marginBottom': '16px' }}>
                            <Link to="/"><Button style={{ "marginTop": "15px" }} data-testid="SignInButton" bsPrefix="float-left button__TO" type="button" onClick={() => pushAnalytics('aa-action', { button_action: 'goToSignIn', ctaText: 'Sign In', initiator: 'user' }, COMPONENT_TREE)}>Sign In</Button></Link>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default RegisterCompleteView;